import { render, staticRenderFns } from "./PersonalSetting.vue?vue&type=template&id=f4672c70&scoped=true"
import script from "./PersonalSetting.vue?vue&type=script&lang=js"
export * from "./PersonalSetting.vue?vue&type=script&lang=js"
import style0 from "./PersonalSetting.vue?vue&type=style&index=0&id=f4672c70&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4672c70",
  null
  
)

export default component.exports